import KoioteTabla from "./KoioteTabla.vue";
import KoioteTablaProperties from "./KoioteTablaProperties.vue";
import KoioteTabla1Property from "./default.json";

export default {
  install(Vue) {
    Vue.component(KoioteTabla.name, KoioteTabla);
    Vue.component(KoioteTablaProperties.name, KoioteTablaProperties);
    Vue.prototype.$TablaProperties = KoioteTabla1Property;
  },
};
